import { bindActionCreators } from "redux";
import {
	Action,
	USER_SET_EMAIL,
	USER_SURVEY_PASSED,
	USER_SIGN_OUT,
	USER_BUY,
	USER_LANGUAGE_SWITCHED,
	USER_CREATE,
	USER_GET_BY_ID,
	CREATE_USER_WITH_EMAIL_AND_PASSWORD,
	SIGN_IN_USER_WITH_EMAIL_AND_PASSWORD,
	SEND_PASSWORD_RESET_EMAIL
} from ".";
import store from "./../reducers";

export default bindActionCreators({
	userCreate: (email) => Action(USER_CREATE, { email }),
	enterEmail: (email) => Action(USER_SET_EMAIL, { email }),
	surveyPassed: (uid) => Action(USER_SURVEY_PASSED, uid),
	getUserById: (uid) => Action(USER_GET_BY_ID, uid),
	signOut: () => Action(USER_SIGN_OUT),
	buy: (email) => Action(USER_BUY, { email }),
	
	languageSwitched: (lang) => Action(USER_LANGUAGE_SWITCHED, lang),
	userCreateWithEmailAndPass: ({ email, password }) => Action(CREATE_USER_WITH_EMAIL_AND_PASSWORD, {
		email,
		password
	}),
	signInWithEmailAndPassword: ({ email, password }) => Action(SIGN_IN_USER_WITH_EMAIL_AND_PASSWORD, {
		email,
		password
	}),
	
	sendPasswordResetEmail: ({ email }) => Action(SEND_PASSWORD_RESET_EMAIL, { email }),
}, store.dispatch);




// WEBPACK FOOTER //
// ./src/actions/auth.js